module.exports = __webpack_public_path__ + "static/media/img-talentx-app.c407feed.png";